export enum WatchListTab {
  PERPS = 'PERPS',
  SPOT = 'SPOT',
  FUTURE = 'FUTURE',
  OPTIONS = 'OPTIONS',
}
